import { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

interface SEOProps {
    title: string;
    description: string;
    keywords?: string;
    path?: string; // Relative path for canonical/hreflang e.g., '/blog/my-post' (without lang prefix)
}

export const useSEO = ({ title, description, keywords, path }: SEOProps) => {
    const { language } = useLanguage();

    useEffect(() => {
        // Title
        document.title = title;

        // Meta Description
        let metaDesc = document.querySelector('meta[name="description"]');
        if (!metaDesc) {
            metaDesc = document.createElement('meta');
            metaDesc.setAttribute('name', 'description');
            document.head.appendChild(metaDesc);
        }
        metaDesc.setAttribute('content', description);

        // Keywords
        if (keywords) {
            let metaKeywords = document.querySelector('meta[name="keywords"]');
            if (!metaKeywords) {
                metaKeywords = document.createElement('meta');
                metaKeywords.setAttribute('name', 'keywords');
                document.head.appendChild(metaKeywords);
            }
            metaKeywords.setAttribute('content', keywords);
        }

        // Canonical & Hreflang
        if (path) {
            const baseUrl = 'https://www.qrcodeforge.com';

            // Canonical
            let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
            if (!canonicalLink) {
                canonicalLink = document.createElement('link');
                canonicalLink.rel = 'canonical';
                document.head.appendChild(canonicalLink);
            }
            canonicalLink.href = `${baseUrl}/${language}${path}`;

            // Hreflang
            const updateHrefLang = (lang: string, url: string) => {
                let hrefLangLink = document.querySelector(`link[hreflang="${lang}"]`) as HTMLLinkElement;
                if (!hrefLangLink) {
                    hrefLangLink = document.createElement('link');
                    hrefLangLink.rel = 'alternate';
                    hrefLangLink.hreflang = lang;
                    document.head.appendChild(hrefLangLink);
                }
                hrefLangLink.href = url;
            };

            updateHrefLang('en', `${baseUrl}/en${path}`);
            updateHrefLang('zh', `${baseUrl}/zh${path}`);
            updateHrefLang('x-default', `${baseUrl}/en${path}`);
        }
    }, [title, description, keywords, path, language]);
};
